<ms-scroll-adapter [alwaysShowArrows]="false">
    <div class="tournament-races-container">
        @for (f of vm.fixtures; track $index) {
            <div
                [ngClass]="
                    isGreyhoundsStyle
                        ? 'day-of-race-meeting-list-greyhounds__race ms-active-highlight'
                        : 'day-of-race-meeting-list__race ms-active-highlight'
                ">
                @if (isGreyhoundsStyle) {
                    <div>
                        <a class="meeting-list-item-details" [href]="f.fixtureUrl" (click)="track(f.fixture)">
                            <div class="greyhounds-race-time">{{ f.fixture.startDate | date: 'HH:mm' }}</div>
                            @if (f.fixture.addons.pricingState === pricingStates.Resulted) {
                                <div class="resulted">
                                    <vn-icon name="sports-race-resulted" width="8" height="13"></vn-icon>
                                </div>
                            }
                            @if (crmPromotedFixtureIdsMap[f.fixture.id]) {
                                <ms-promotion-badge class="no-title"></ms-promotion-badge>
                            }
                            @if (f.fixture.addons.pricingState === pricingStates.Priced) {
                                <div class="gh-race-off-meeting">
                                    <vn-icon name="sports-priced" size="12"></vn-icon>
                                </div>
                            }
                            @if (f.fixture.addons.pricingState === pricingStates.RaceOff) {
                                <div class="gh-race-off-meeting">
                                    <vn-icon class="greyhounds-race-off gh-greyhounds-race-off" name="sports-greyhounds-race-off" size="12"></vn-icon>
                                </div>
                            }
                            <ms-race-view-best-odds-badge [fixture]="f.fixture"></ms-race-view-best-odds-badge>
                        </a>
                    </div>
                } @else {
                    <a [href]="f.fixtureUrl">
                        <div class="race-time">{{ f.fixture.startDate | date: 'HH:mm' }}</div>
                        @if (f.fixture.addons.pricingState === pricingStates.Resulted) {
                            <div class="resulted">
                                <vn-icon name="sports-race-resulted" width="8" height="12"></vn-icon>
                            </div>
                        }
                        @if (crmPromotedFixtureIdsMap[f.fixture.id]) {
                            <ms-promotion-badge class="no-title"></ms-promotion-badge>
                        }
                        @if (f.fixture.addons.pricingState === pricingStates.Priced) {
                            <div class="priced">P</div>
                        }
                        @if (f.fixture.addons.pricingState === pricingStates.RaceOff) {
                            <div class="started">O</div>
                        }
                        <ms-race-view-best-odds-badge [fixture]="f.fixture"></ms-race-view-best-odds-badge>
                    </a>
                }
            </div>
        }
    </div>
</ms-scroll-adapter>
